import { render, staticRenderFns } from "./dropzone-popup.vue?vue&type=template&id=c36b3e58&"
import script from "./dropzone-popup.vue?vue&type=script&lang=js&"
export * from "./dropzone-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports